<script>
	// From Lucide
	import { ArrowLeft } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ArrowLeft class={iconClass} />
